export function OutlineAeropuertosIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.42 3.87891L4.25 9.18891L3 8.18891"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.74023 5.28906L9.81023 5.66906L8.16023 10.0391"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1499 6.75H21.1499L20.1499 12H16.1499L15.1499 6.75Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1499 7V3"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1499 12V19C20.1499 20.1 19.2499 21 18.1499 21H16.1499V12H20.1499Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1499 14.0001V21.0001H7.1499C6.0499 21.0001 5.1499 20.1001 5.1499 19.0001V15.7401C6.4399 15.0501 8.1199 14.3601 10.1499 14.0001C12.6499 13.5501 14.7699 13.7501 16.1499 14.0001Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M16.1499 14.0001C14.7699 13.7501 12.6499 13.5501 10.1499 14.0001C8.1199 14.3601 6.4399 15.0501 5.1499 15.7401C4.3099 16.1901 3.6499 16.6401 3.1499 17.0001"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10.1499 18V20" stroke={stroke} strokeWidth={strokeWidth} strokeLinejoin="round" />
      <path d="M12.1499 18V20" stroke={stroke} strokeWidth={strokeWidth} strokeLinejoin="round" />
    </svg>
  );
}
